export const MAPS_API_KEY = process.env.VUE_APP_MAPS_API_KEY;
